export class Upload {
  id: string
  media: {
    medium?: string
    thumbnail?: string
    original?: string,
    video?: string,
    video_small?: string
  } | null
  dimensions: {
    width: number
    height: number
    aspect: number
  }
  timestamp: number
  mime_type: string

  static EXAMPLE_ID_PREFIX = "example_"

  constructor() {
    this.id = "example"
    this.media = null
    this.timestamp = 0
    this.mime_type = "example/example"
    this.dimensions = {
      width: 0,
      height: 0,
      aspect: 0
    }
  }

  static example(uniqueId: number = 0) {
    let example = new Upload()
    example.id = `${Upload.EXAMPLE_ID_PREFIX}${uniqueId}`
    example.mime_type = "image/jpg"

    let exampleNumber = (Math.round(uniqueId) % 3) + 1
    
    let medium = `${process.env.PUBLIC_URL}/img/example${exampleNumber}_sm.jpg`
    let fullSize = `${process.env.PUBLIC_URL}/img/example${exampleNumber}.jpg`

    example.media = {
      medium: medium,
      thumbnail: medium,
      original: fullSize
    }

    example.dimensions = {
      width: 960,
      height: 1280,
      aspect: 0.75
    }

    return example
  }

  static getExamples(number: number): Upload[] {
    let uploads: Upload[] = []
    for (let i = 0; i < number; i++) {
      uploads.push(Upload.example(i))
    }
    return uploads
  }
}

export enum Quality {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH"
}
export type QualityEnum = keyof typeof Quality;